<template>
	<div>
		<v-dialog v-model="dialog_tax" no-click-animation scrollable persistent content-class="full-height" transition="dialog-bottom-transition">
			<v-card>
	        	<v-card-title noshadow class="dialog_searchbox">
	        		<v-subheader full-width class="pr-0">
	        			Select Tax Category
	        			<v-spacer></v-spacer>
	        			<v-btn flat icon @click="fn_newTaxCategory">
	        				<v-icon class="primary-color">add</v-icon>
	        			</v-btn>
	        		</v-subheader>
	        	</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>

			        <v-list nopadding v-if="taxCategories && taxCategories.length">
			        	<v-list-tile v-for="(item, index) in taxCategories" :key="index" @click="updateTaxCategory(item)">

				            <v-list-tile-content>
				              <v-list-tile-title>{{item.taxCategoryName}}</v-list-tile-title>
				            </v-list-tile-content>

				            <v-list-tile-action>
						        <v-icon v-if="item.taxCategoryId == selectedTaxCategoryId">radio_button_checked</v-icon>
						        <v-icon v-else>radio_button_unchecked</v-icon>
				            </v-list-tile-action>

			        	</v-list-tile>
			        </v-list>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		        </v-card-actions>
		    </v-card>

	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['taxCategories', 'updateTaxCategory', 'selectedTaxCategoryId'],
		data(){
			return{
				dialog_tax:false,
				hide_overlay:true
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_tax = true;
			},
			closeDialogWeb: function () {
				this.dialog_tax = false;
			},
			fn_newTaxCategory: function(){
				this.$parent.backButtonPress = false;
				if(this.$parent.taxCategoryType == 'old'){
					this.$router.push({path:"/tax/category/items/new", query:{tagId:this.guidWeb(), ls:1}});
				}
				else{
					this.$router.push({path:"/tax/category/items/new", query:{tagId:this.guidWeb(), ls:1, new:1}});
				}
				
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_tax_categories.vue